import { GetMoreQuestionMeta, GetMoreQuestionPayload } from 'types/store/GetMoreQuestion';
import { createAsyncReducer } from 'utils/Redux';

import { getMoreQuestionActions } from '../actions';

export default createAsyncReducer<GetMoreQuestionMeta, GetMoreQuestionPayload>(getMoreQuestionActions);
